export default __webpack_public_path__ + "static/media/tickets_outline-01.2f4ee4e8.svg";